'use strict';

import { LineGeometry } from 'three/examples/jsm/lines/LineGeometry';
import { LineMaterial } from 'three/examples/jsm/lines/LineMaterial';
import { Line2 } from 'three/examples/jsm/lines/Line2';
import { BufferGeometry, CatmullRomCurve3, Color, LinearSRGBColorSpace } from 'three';
import { SelectedObjectType } from '../../../../common';
import { settingsData } from '../../../../settings';

export class RoutsEnvironment {
    constructor () {
        this.animations = [];
    }

    buildRoute(object) {
        if (object.buildedRoute || object.route.length < 2 || config.features.poi?.hideRoutes && object.tags.building === 'train_station')
            return;

        // const curve = new CatmullRomCurve3(object.route);
        // curve.curveType = 'centripetal';
        // curve.tension = 0.5;
        // const curvedPoint = curve.getPoints(10);
        const geometry = new BufferGeometry().setFromPoints(object.route);
        const lineGeometry = new LineGeometry().setPositions(geometry.getAttribute('position').array);
        const routeLineMaterial = new LineMaterial({
            color: new Color().setStyle(object.tags.assets.route,LinearSRGBColorSpace),
            linewidth: object.tags.assets.linewidth || 5,
            dashed: false,
            opacity: 0.9,
            alphaToCoverage: true,
            depthTest: object.tags.assets.depthTest || true,
            depthWrite: object.tags.assets.depthTest || true,
            transparent: !object.tags.assets.depthTest || false
        });
        routeLineMaterial.resolution.set( window.innerWidth / 4, window.innerHeight / 4 );
        const dashRouteLineMaterial = new LineMaterial({
            color: new Color().setStyle('#ffffff',LinearSRGBColorSpace),
            linewidth: object.tags.assets.linewidth || 5,
            dashed: true,
            dashOffset: 1,
            opacity: 0.6,
            gapSize: 20,
            dashSize: 10,
            alphaToCoverage: true,
            depthTest: object.tags.assets.depthTest || true,
            depthWrite: object.tags.assets.depthTest || true,
            transparent: !object.tags.assets.depthTest || false
        });
        
        dashRouteLineMaterial.resolution.set( window.innerWidth / 4, window.innerHeight / 4 );
        const dashLine = new Line2(lineGeometry,dashRouteLineMaterial);
        dashLine.name = 'route_dash';
        dashLine.computeLineDistances();
        dashLine.scale.set(1,1,1);

        dashRouteLineMaterial.tick = () => {
            dashRouteLineMaterial.dashOffset -= 1;
        };

        const line = new Line2(lineGeometry,routeLineMaterial);
        line.name = 'route_line';
        line.computeLineDistances();
        line.scale.set(1,1,1);
        line.userData.id = object.id;
        line.userData.environmentId = this.id;
        line.userData.type = SelectedObjectType.Route;
        dashLine.userData.id = object.id;

        this.animations.push(dashRouteLineMaterial);

        object.buildedRoute = {
            line,
            dashLine
        };

        this.group.add(line);
        this.group.add(dashLine);

        if (this.id === 'Highway') {
            settingsData.objects_to_intersection.push(line);
        }
    }

    removePreviouslyRoute() {
        const object = this.objects.find(obj => obj.buildedRoute);
        object && this.removeRoute(object);
    }

    removeRoute(object) {
        if (!object.buildedRoute) return;
        Object.values(object.buildedRoute).forEach(el => {
            el.removeFromParent();
            el.geometry.dispose();
            this.animations = this.animations.filter(material => material !== el.material);
            el.material.dispose();
            settingsData.objects_to_intersection = settingsData.objects_to_intersection.filter(intersectedObject => intersectedObject !== el);
        });

        delete object.buildedRoute;
    }

    tick(delta) {
        this.animations.forEach(material => material.tick(delta));
    }

}
